"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferValidationSchema = exports.tokenZeroAssetValidationSchema = exports.tokenZeroAssetComponentValidationSchema = void 0;
const yup_1 = require("yup");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
const types_1 = require("@framework/types");
exports.tokenZeroAssetComponentValidationSchema = (0, yup_1.object)().shape({
    tokenType: mui_inputs_asset_1.tokenAssetTokenTypeValidationSchema,
    contractId: yup_rules_1.dbIdValidationSchema,
    token: (0, yup_1.object)().when("tokenType", {
        is: (tokenType) => tokenType !== types_1.TokenType.ERC20 && tokenType !== types_1.TokenType.NATIVE,
        then: schema => schema.shape({
            tokenId: (0, yup_1.number)()
                .min(0, "form.validations.valueMissing")
                .integer("form.validations.badInput")
                .required("form.validations.valueMissing"),
        }),
    }),
    amount: mui_inputs_asset_1.tokenAssetAmountValidationSchema,
});
exports.tokenZeroAssetValidationSchema = (0, yup_1.object)().shape({
    components: (0, yup_1.array)().of(exports.tokenZeroAssetComponentValidationSchema),
});
exports.transferValidationSchema = (0, yup_1.object)().shape({
    token: exports.tokenZeroAssetValidationSchema,
    address: yup_rules_eth_1.addressValidationSchema,
});
//# sourceMappingURL=validation.js.map